export default __webpack_public_path__ + "static/media/evenshot.a35061a6.png";